import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { useHistory } from 'react-router-dom';
import { connect } from "react-redux";
import { Button } from 'devextreme-react/button';
import { confirm, alert } from 'devextreme/ui/dialog';
import axios from "axios";
import { LoadPanel } from 'devextreme-react/load-panel';
import notify from 'devextreme/ui/notify';
import { createStore } from 'devextreme-aspnet-data-nojquery';
import DataSource from "devextreme/data/data_source";
import Toolbar, { Item } from "devextreme-react/toolbar";
import { NumberBox, TextBox, SelectBox } from "devextreme-react";
import { formatMessage } from 'devextreme/localization';
import { Localization } from "../../common/Localization";
import { useLocation } from 'react-router-dom';
import { INVENTORY_OPERATIONS, filterVisibleOperations } from "./inventoryOperations";

function InventoryOperation(props) {
    const operationMarkForSale = 1;
    const operationAddInventory = 2;
    const operationRemoveDead = 3;
    const operationMoveFromLocation = 4;
    const operationMoveToLocation = 5;
    const operationMarkNotForSale = 6;
    const operationQuantityShipped = 7;
    const itemTypeLot = "L";
    // Localized field labels (fall back to the English default when no dictionary entry exists).
    const labelFromLocation = Localization.formatMessage('FromLocation', 'From Location');
    const labelToLocation = Localization.formatMessage('ToLocation', 'To Location');
    const labelChooseLocation = Localization.formatMessage('ChooseLocation', 'Choose Location');
    const labelSite = Localization.formatMessage('Site', 'Site');
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const selectedOperation = queryParams.get('selectedOperation');
    const rowIdParam = queryParams.get('id');
    console.log(selectedOperation);
    const rlotRef = useRef(null);
    const [dialogVisible, setDialogVisible] = useState(false);
    const [inventoryOperations, setInventoryOperations] = useState(INVENTORY_OPERATIONS);
    // Operations hidden for the user's role (Manage Settings -> Inventory Management) are
    // dropped from the Operation dropdown. Empty/missing claim => all operations visible.
    const visibleOperations = useMemo(
        () => filterVisibleOperations(inventoryOperations, props.oidc?.user?.profile?.IMHIDDENOPERATIONS),
        [inventoryOperations, props.oidc?.user?.profile?.IMHIDDENOPERATIONS]
    );
    const [isMobileView, setIsMobileView] = useState(false);
    const [itemType, setItemType] = useState("");
    const updateView = () => {
        setIsMobileView(window.innerWidth <= 768);
    };

    //console.log(props.oidc.user.profile.IMDEFAULTREASONCODEUNAVAILABLEITEMS);

    const initialFormFields = {
        Rowid: '00000000-0000-0000-0000-000000000000',
        selectedOperation: selectedOperation,
        RWarehouse: '',
        ItemWarehouse: '',
        itemDescription1: '',
        RLocation: '',
        Quantity: '',
        RFromLocation: '',
        imDefaultReasonCodeUnavailableItems: props.oidc.user.profile.hasOwnProperty("IMDEFAULTREASONCODEUNAVAILABLEITEMS") ? props.oidc.user.profile.IMDEFAULTREASONCODEUNAVAILABLEITEMS : "",
        imDefaultReceiptProfile: props.oidc.user.profile.hasOwnProperty("IMDEFAULTRECEIPTPROFILE") ? props.oidc.user.profile.IMDEFAULTRECEIPTPROFILE : "",
        imDefaultUsageProfile: props.oidc.user.profile.hasOwnProperty("IMDEFAULTUSAGEPROFILE") ? props.oidc.user.profile.IMDEFAULTUSAGEPROFILE : "",
        imDefaultAdjustmentProfile: props.oidc.user.profile.hasOwnProperty("IMDEFAULTADJUSTMENTPROFILE") ? props.oidc.user.profile.IMDEFAULTADJUSTMENTPROFILE : "",
        formFields: '',

    };
    const [formFields, setformFields] = useState(initialFormFields);
    const history = useHistory();
    var accessToken = props.oidc.user.access_token;
    const [locationLabel, setLocationLabel] = useState(labelChooseLocation);
    const [fromLocationLabel, setFromLocationLabel] = useState(labelFromLocation);
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const [loadPanelVisible, setLoadPanelVisible] = useState(false);
    const [isFormSubmitted, setIsFormSubmitted] = useState(false);
    const hideLoadPanel = useCallback(() => {
        setLoadPanelVisible(false);
    }, [setLoadPanelVisible]);
    const position = { of: '#accordion-containe2' };
    var currentUser = props.oidc.user;
    const formRefs = useRef({});
    const handleFormSubmit = async (e) => {

        try {
            e.preventDefault();

            console.log(formFields);
            if (formFields.selectedOperation == 0) {
                notify(
                    {
                        message: 'Please Select the Operation',
                        width: 300,
                        position: {
                            my: 'center',
                            at: 'center',
                            of: window,
                        },
                    },
                    'error',
                    3000
                );
                return;
            }
            if (formFields.selectedOperation == operationMarkForSale) {
                const validateUrl = "im/Transactionlocation/validateTransactionMarkForSale";
                const processUrl = "im/Transactionlocation/InventoryOperationMarkForSale";
                await validateOperation(validateUrl, processUrl, operationMarkForSale, "Mark For Sale");
            } else if (formFields.selectedOperation == operationAddInventory) {
                const validateUrl = "im/Transactionlocation/validateTransactionAddInventory";
                const processUrl = "im/Transactionlocation/InventoryOperationAddInventory";
                await validateOperation(validateUrl, processUrl, operationAddInventory, "Add Inventory");
            } else if (formFields.selectedOperation == operationRemoveDead) {
                const validateUrl = "im/Transactionlocation/validateTransactionRemoveInventory";
                const processUrl = "im/Transactionlocation/InventoryOperationRemoveInventory";
                await validateOperation(validateUrl, processUrl, operationRemoveDead, "Remove Dead");
            } else if (formFields.selectedOperation == operationMoveFromLocation) {
                const validateUrl = "im/Transactionlocation/validateTransactionMoveFromLocation";
                const processUrl = "im/Transactionlocation/InventoryOperationMoveFromLocation";
                await validateOperation(validateUrl, processUrl, operationMoveFromLocation, "Move From Location");
            } else if (formFields.selectedOperation == operationMoveToLocation) {
                const validateUrl = "im/Transactionlocation/validateTransactionMoveFromLocation";
                const processUrl = "im/Transactionlocation/InventoryOperationMoveToLocation";
                await validateOperation(validateUrl, processUrl, operationMoveToLocation, "Move To Location");
            } else if (formFields.selectedOperation == operationQuantityShipped) {
                const validateUrl = "im/Transactionlocation/validateTransactionQuantityShipped";
                const processUrl = "im/Transactionlocation/InventoryOperationQuantityShipped";
                await validateOperation(validateUrl, processUrl, operationQuantityShipped, "Quantity Shipped");
            }
            else if (formFields.selectedOperation == operationMarkNotForSale) {
                const validateUrl = "im/Transactionlocation/validateTransactionMarkNotForSale";
                const processUrl = "im/Transactionlocation/InventoryOperationMarkNotForSale";
                await validateOperation(validateUrl, processUrl, operationMarkNotForSale, "Mark Not For Sale");
            }
        } catch (error) {
            console.error('Error submitting form:', error);
        } finally {
            setTimeout(hideLoadPanel, 1000);

        }
    };
    const ProcessOperation = async (processUrl) => {
        setLoadPanelVisible(true);
        setIsFormSubmitted(true);
        try {
            let fields = formFields;
            if (itemType !== itemTypeLot) {
                fields.RLOT = '';
              }
            const response = await axios.post(`${window._env_.REACT_APP_APIS}/${processUrl}`, fields, {
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                },
            });
            console.log(response);
            if (response.data.issuccess) {
                notify(
                    {
                        message: response.data.message,
                        width: 300,
                        position: {
                            my: 'center',
                            at: 'center',
                            of: window,
                        },
                    },
                    'success',
                    3000,
                );
                history.push({
                    pathname: '/im/TransactionEntryForm/TransactionEntryForm'
                });
            } else {
                setIsFormSubmitted(false);
                notify(
                    {
                        message: response.data.message,
                        width: 300,
                        position: {
                            my: 'center',
                            at: 'center',
                            of: window,
                        },
                    },
                    'error',
                    3000,
                );
            }


        } catch (error) {
            setIsFormSubmitted(false);
            console.error('Error submitting form:', error);
            notify(
                {
                    message: error,
                    width: 300,
                    position: {
                        my: 'center',
                        at: 'center',
                        of: window,
                    },
                },
                'error',
                3000,
            );
        } finally {
            setTimeout(hideLoadPanel, 1000);
        }
    };
    const validateOperation = async (validateUrl, processUrl, operation, title) => {

        try {
            let fields = formFields;
            const response = await axios.post(`${window._env_.REACT_APP_APIS}/${validateUrl}`, fields, {
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                },
            });
            if (response.data.issuccess) {
                // Passed validation — process straight away.
                setLoadPanelVisible(true);
                ProcessOperation(processUrl);
            } else if (response.data.iswarning) {
                // Bypassable warning (e.g. quantity adjusted) — the user may confirm and continue.
                const result = confirm({
                    message: `<i>${response.data.message}</i>`,
                    title: title || "Confirmation",
                    buttons: [
                        { text: "Yes", onClick: () => true },
                        { text: "No", onClick: () => false }
                    ]
                });
                result.then((dialogResult) => {
                    if (dialogResult) {
                        setLoadPanelVisible(true);
                        if (operation == operationMarkForSale || operation == operationRemoveDead) {
                            setformFields(prevState => ({
                                ...prevState,
                                'Quantity': response.data.quantity,
                            }));
                        }
                        ProcessOperation(processUrl);
                    } else {
                        setTimeout(hideLoadPanel, 1000);
                    }
                });
            } else {
                // Hard validation error (e.g. insufficient/no available quantity) — show the message and
                // stop; the operation cannot proceed.
                setIsFormSubmitted(false);
                alert(`<i>${response.data.message}</i>`, title || "Validation");
                setTimeout(hideLoadPanel, 1000);
            }

        } catch (error) {
            console.error('Error submitting form:', error);
            setTimeout(hideLoadPanel, 1000);
        } finally {
        }
    };


    const handleReset = () => {
        var rowid = rowIdParam;
        if (rowid != null && rowid != undefined && rowid != '') {
            GetHeaderInfoById(rowid);
        }
        else {
            setformFields(initialFormFields);
            EnableControlsForNewRecord();
        }
    };
    const GetHeaderInfoById = (id) => {
        try {
            setLoadPanelVisible(true);
            const response = axios.get(`${window._env_.REACT_APP_APIS}/im/Transactionlocation/GetItemLocationTransactionByRowId?rowid=${id}`, {
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                }
            }).then((res) => {
                const responseData = res.data;
                const profileString = JSON.stringify(responseData, null, 2);
                console.log(profileString);
                setInventoryOperations(responseData?.inventoryOperation);
                console.log(responseData);
                loadInventoryItemDataByWarehouse(responseData.ItemWarehouse);
                setformFields(responseData);
                setItemType(responseData.ItemType);
                if (responseData.ItemType == itemTypeLot) {
                    loadInventoryLotData(responseData.RItem);
                }
                setformFields(prevState => ({
                    ...prevState,
                    'imDefaultReasonCodeUnavailableItems': props.oidc.user.profile.hasOwnProperty("IMDEFAULTREASONCODEUNAVAILABLEITEMS") ? props.oidc.user.profile.IMDEFAULTREASONCODEUNAVAILABLEITEMS : "",
                    'imDefaultReceiptProfile': props.oidc.user.profile.hasOwnProperty("IMDEFAULTRECEIPTPROFILE") ? props.oidc.user.profile.IMDEFAULTRECEIPTPROFILE : "",
                    'imDefaultUsageProfile': props.oidc.user.profile.hasOwnProperty("IMDEFAULTUSAGEPROFILE") ? props.oidc.user.profile.IMDEFAULTUSAGEPROFILE : "",
                    'imDefaultAdjustmentProfile': props.oidc.user.profile.hasOwnProperty("IMDEFAULTADJUSTMENTPROFILE") ? props.oidc.user.profile.IMDEFAULTADJUSTMENTPROFILE : "",
                    'selectedOperation': selectedOperation,
                }));
                console.log('selectedOperation=' + selectedOperation);
                console.log(JSON.stringify(formFields, null, 2));
                loadLocationData(responseData?.RWarehouse, responseData?.LocationModule);
                loadFromLocationData(responseData?.RWarehouse, responseData?.LocationModule);
            });

            // 
        } catch (error) {
            console.error('Error failed to get transaction data:', error);
        } finally {
            setTimeout(hideLoadPanel, 1000);
        }
    };
    const EnableControlsForNewRecord = () => {
    }
    const [inventoryItemCodesData, setinventoryItemCodesData] = useState([]);
    const [inventoryLotData, setinventoryLotData] = useState([]);
    const [warehouseData, setWarehouseData] = useState([]);
    const [itemWarehouseData, setItemWarehouseData] = useState([]);
    const loadItemWarehouseData = () => {
        var apiMethod = "id/Lookup/GetWarehouses";
        const resultData = createStore({
            key: 'id',
            loadParams:
            {

            },
            loadUrl: `${window._env_.REACT_APP_APIS}/${apiMethod}`,
            onBeforeSend: (method, ajaxOptions) => {
                ajaxOptions.headers = {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                };
            },
        });
        setItemWarehouseData(resultData)
    };
    const loadWarehouseData = () => {
        var apiMethod = "id/Lookup/GetWarehouses";
        const resultData = createStore({
            key: 'id',
            loadParams:
            {

            },
            loadUrl: `${window._env_.REACT_APP_APIS}/${apiMethod}`,
            onBeforeSend: (method, ajaxOptions) => {
                ajaxOptions.headers = {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                };
            },
        });
        setWarehouseData(resultData)
    };
    const loadInventoryLotData = (itemId) => {
        var apiMethod = "im/Lookup/GetLots";
        const resultData = createStore({
            key: 'id',
            loadParams:
            {
                ItemId: itemId
            },
            loadUrl: `${window._env_.REACT_APP_APIS}/${apiMethod}`,
            onBeforeSend: (method, ajaxOptions) => {
                ajaxOptions.headers = {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                };
            },
        });
        setinventoryLotData(resultData)
    };
    const loadInventoryItemDataByWarehouse = (ItemWareHouseId) => {
        var apiMethod = "im/Lookup/GetItems";
        const resultData = createStore({
            key: 'id',
            loadParams:
            {
                ItemWareHouseId: ItemWareHouseId
            },
            loadUrl: `${window._env_.REACT_APP_APIS}/${apiMethod}`,
            onBeforeSend: (method, ajaxOptions) => {
                ajaxOptions.headers = {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                };
            },
        });

        setinventoryItemCodesData(resultData)
    };
    const loadInventoryItemData = () => {
        var apiMethod = "im/Lookup/GetItems";
        var sadf = formFields['ItemWarehouse'];

        const resultData = createStore({
            key: 'id',
            loadParams:
            {
                ItemWareHouseId: formFields['ItemWarehouse']
            },
            loadUrl: `${window._env_.REACT_APP_APIS}/${apiMethod}`,
            onBeforeSend: (method, ajaxOptions) => {
                ajaxOptions.headers = {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                };
            },
        });

        setinventoryItemCodesData(resultData)
    };
    useEffect(() => {
        var rowid = rowIdParam;
        if (rowid != null && rowid != undefined && rowid != '') {
            GetHeaderInfoById(rowid);
        }
        else {
            EnableControlsForNewRecord();
        }
        //console.log("selectedOperation"+ props.selectedOperation)
        loadWarehouseData();
        loadItemWarehouseData();
        //loadInventoryItemData();


       /* updateView();
        window.addEventListener("resize", updateView);

        return () => {
            window.removeEventListener("resize", updateView);
        };*/

    }, [rowIdParam]);
    const goBack = () => {
        history.goBack();
    };
    const handleFieldChange = useCallback((name, value, e, selectedItemType) => {
         
        if (name == 'RItem') {
            setItemType(selectedItemType);
            if (rlotRef.current) {
                rlotRef.current.instance().reset();  
            }
            loadInventoryLotData(value);
        }
        if (name == 'ItemWarehouse') {
            loadInventoryItemDataByWarehouse(value);
        }
        if (name === 'selectedOperation') {
            if (value == operationMoveFromLocation || value == operationMoveToLocation) {
                // Move To mirrors Move From: the current location shown in the From Location box is the
                // destination, so relabel it "To Location" and label the choice "From Location".
                setFromLocationLabel(value == operationMoveToLocation ? labelToLocation : labelFromLocation);
                setLocationLabel(value == operationMoveToLocation ? labelFromLocation : labelToLocation);
            } else {
                setFromLocationLabel(labelFromLocation);
                setLocationLabel(labelChooseLocation);
            }
        }
        setformFields(prevState => ({
            ...prevState,
            [name]: value,
        }));
        if (name == 'RWarehouse') {
            loadLocationData(value);
        }
    }, []);

    const [dateSourceLocation, setDateSourceLocation] = useState(null);
    const [dateSourceFromLocation, setDateSourceFromLocation] = useState(null);
    const loadLocationData = useCallback((value, module) => {
        var dataSourceDB = new DataSource({
            store: new createStore({
                key: 'id',
                loadParams: {
                    warehouseRowId: function () {
                        return value;
                    },
                    module: function () {
                        return module ?? 'IM';
                    }
                },
                loadUrl: `${window._env_.REACT_APP_APIS}/im/Lookup/GetLocations`,
                onBeforeSend: function (method, ajaxOptions) {
                    ajaxOptions.headers = {
                        Authorization: `Bearer ${accessToken}`
                    };
                }
            }),
            paginate: true,
            pageSize: 100
        });
        setDateSourceLocation(dataSourceDB);
    }, []);

    const loadFromLocationData = useCallback((value, module) => {
        var dataSourceDB = new DataSource({
            store: new createStore({
                key: 'id',
                loadParams: {
                    warehouseRowId: function () {
                        return value;
                    },
                    module: function () {
                        return module ?? 'IM';
                    }
                },
                loadUrl: `${window._env_.REACT_APP_APIS}/im/Lookup/GetLocations`,
                onBeforeSend: function (method, ajaxOptions) {
                    ajaxOptions.headers = {
                        Authorization: `Bearer ${accessToken}`
                    };
                }
            }),
            paginate: true,
            pageSize: 100
        });
        setDateSourceFromLocation(dataSourceDB);
    }, []);
    const Back = () => {
        history.push({
            pathname: '/im/TransactionEntryForm/TransactionEntryForm'
        });
        return;
    };
    // A move operation (From or To) shares the same From/To location UI; derive once instead of repeating the guard.
    const isMoveOperation =
        formFields['selectedOperation'] === operationMoveFromLocation ||
        formFields['selectedOperation'] === operationMoveToLocation;
    return (
        <>
            <div>
                <div className="row dataEntryMainPage">
                    <div className="col-md-12 main-page">
                        <div id="accordion">

                            <LoadPanel
                                shadingColor="rgba(0,0,0,0.4)"
                                position={position}
                                onHiding={hideLoadPanel}
                                visible={loadPanelVisible}
                                showIndicator={true}
                                shading={true}
                                showPane={true}
                                hideOnOutsideClick={false}
                            />
                            <form onSubmit={(e) => handleFormSubmit(e)}>
                                <Toolbar className="header">
                                    <Item location="before">
                                        <div className="title">
                                            <h6
                                                style={{
                                                    color: window._env_.Color2,
                                                    marginLeft: '12px'
                                                }}
                                            >
                                                Inventory Operation
                                            </h6>
                                        </div>
                                    </Item>
                                    <Item location="after" visible={!isMobileView}>
                                        <Button
                                            text="Save"
                                            useSubmitBehavior={true}
                                            type="default"
                                            className="accordianButton"
                                            disabled={isFormSubmitted}
                                        />
                                    </Item>
                                    <Item location="after" visible={!isMobileView}>
                                        <Button className="accordianButton" onClick={handleReset} disabled={isFormSubmitted} text="Reset" />
                                    </Item>
                                    <Item location="after">
                                        <Button onClick={Back} text="Back" icon="back" visible={!isMobileView}>
                                        </Button>
                                    </Item>
                                </Toolbar>
                                <div className="AccordionItemBody">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <SelectBox
                                                dataSource={visibleOperations}
                                                name="selectedOperation"
                                                value={parseInt(formFields['selectedOperation'], 10)} 
                                                onValueChanged={(e) => handleFieldChange('selectedOperation', e.value, e)}
                                                searchEnabled={false}
                                                stylingMode="outlined"
                                                labelMode="static"
                                                label={formatMessage('Operation')}
                                                displayExpr="Name"
                                                valueExpr="Id"
                                            >
                                            </SelectBox>

                                        </div>
                                    </div>
                                    {(formFields['selectedOperation'] === operationAddInventory) && (
                                        <div className="row accordianLastRow">
                                            <div className="col-md-12">
                                                <SelectBox
                                                    dataSource={itemWarehouseData}
                                                    name="ItemWarehouse"
                                                    value={formFields['ItemWarehouse']}
                                                    onValueChanged={(e) => handleFieldChange('ItemWarehouse', e.value, e)}
                                                    searchEnabled={true}
                                                    stylingMode="outlined"
                                                    labelMode="static"
                                                    label='Item Warehouse'
                                                    displayExpr="name"
                                                    valueExpr="id"
                                                >
                                                </SelectBox>
                                            </div>
                                        </div>
                                    )}
                                    <div className="row accordianLastRow">
                                        <div className="col-md-12">
                                            {formFields['selectedOperation'] === operationAddInventory ? (
                                                <SelectBox
                                                    dataSource={inventoryItemCodesData}
                                                    name="RItem"
                                                    value={formFields['RItem']}
                                                    onValueChanged={(e) => {
                                                         
                                                        const selectedItem = e.component.option('selectedItem');
                                                        const selectedItemType = selectedItem?.itemType;
                                                        handleFieldChange('RItem', e.value, e, selectedItemType);
                                                    }}
                                                    searchEnabled={true}
                                                    stylingMode="outlined"
                                                    labelMode="static"
                                                    label={formatMessage('Item')}
                                                    displayExpr="name"
                                                    valueExpr="id"
                                                    disabled={false}
                                                >
                                                </SelectBox>
                                            ) : (
                                                <SelectBox
                                                    dataSource={inventoryItemCodesData}
                                                    name="RItem"
                                                    value={formFields['RItem']}
                                                    onValueChanged={(e) => handleFieldChange('RItem', e.value, e)}
                                                    searchEnabled={true}
                                                    stylingMode="outlined"
                                                    labelMode="static"
                                                    label={formatMessage('Item')}
                                                    displayExpr="name"
                                                    valueExpr="id"
                                                    disabled={true}
                                                >
                                                </SelectBox>
                                            )}
                                        </div>
                                    </div>
                                    <div className="row accordianLastRow">
                                        <div className="col-md-12">
                                            <SelectBox
                                                dataSource={inventoryItemCodesData}
                                                name="ItemWarehouse"
                                                value={formFields['RItem']}
                                                searchEnabled={false}
                                                showClearButton={false}
                                                placeholder=""
                                                stylingMode="outlined"
                                                labelMode="static"
                                                label={Localization.formatMessage('IMITEM.IMITEM.DESCRIPTION_2', 'Description- 2')}
                                                displayExpr="itemDescription1"
                                                valueExpr="id"
                                                disabled={true}
                                            >
                                            </SelectBox>
                                        </div>
                                    </div>
                                    <div className="row accordianLastRow">
                                        <div className="col-md-12">
                                            <SelectBox
                                                dataSource={inventoryItemCodesData}
                                                name="ItemWarehouse"
                                                value={formFields['RItem']}
                                                searchEnabled={false}
                                                showClearButton={false}
                                                placeholder=""
                                                stylingMode="outlined"
                                                labelMode="static"
                                                label={Localization.formatMessage('IMITEM.IMITEM.DESCRIPTION_1', 'Description- 1')}
                                                displayExpr="itemDescription2"
                                                valueExpr="id"
                                                disabled={true}
                                            >
                                            </SelectBox>
                                        </div>
                                    </div>
                                    <div className="row accordianLastRow">
                                        <div className="col-md-12">
                                            <SelectBox
                                                dataSource={inventoryItemCodesData}
                                                name="ItemWarehouse"
                                                value={formFields['RItem']}
                                                searchEnabled={false}
                                                showClearButton={false}
                                                placeholder=""
                                                stylingMode="outlined"
                                                labelMode="static"
                                                label={Localization.formatMessage('IMITEM.CLASSCODE', 'Class Code')}
                                                displayExpr="itemClassCode"
                                                valueExpr="id"
                                                disabled={true}
                                            >
                                            </SelectBox>
                                        </div>
                                    </div>
                                    {itemType === itemTypeLot && (
                                        <div className="row accordianLastRow">
                                            <div className="col-md-12">
                                                <SelectBox
                                                    dataSource={inventoryLotData}
                                                    name="RLot"
                                                    ref={rlotRef}
                                                    value={formFields['RLot']}
                                                    onValueChanged={(e) => handleFieldChange('RLot', e.value, e)}
                                                    searchEnabled={true}
                                                    stylingMode="outlined"
                                                    labelMode="static"
                                                    label={formatMessage('Lot')}
                                                    displayExpr="name"
                                                    valueExpr="id"
                                                    disabled={
                                                        !(
                                                            formFields['selectedOperation'] === operationAddInventory ||
                                                            isMoveOperation
                                                        )
                                                    }
                                                />
                                            </div>
                                        </div>
                                    )}

                                    {isMoveOperation && (
                                            <div className="row accordianLastRow">
                                                <div className="col-md-12">
                                                    <SelectBox
                                                        dataSource={dateSourceFromLocation}
                                                        name="RFromLocation"
                                                        value={formFields['RFromLocation']}
                                                        searchEnabled={true}
                                                        stylingMode="outlined"
                                                        labelMode="static"
                                                        label={fromLocationLabel}
                                                        displayExpr="name"
                                                        valueExpr="id"
                                                        disabled={true}
                                                    >
                                                    </SelectBox>
                                                </div>
                                            </div>
                                        )}
                                    <div className="row accordianLastRow">
                                        <div className="col-md-12">
                                            <SelectBox
                                                dataSource={warehouseData}
                                                name="RWarehouse"
                                                value={formFields['RWarehouse']}
                                                onValueChanged={(e) => handleFieldChange('RWarehouse', e.value, e)}
                                                searchEnabled={true}
                                                stylingMode="outlined"
                                                labelMode="static"
                                                label={labelSite}
                                                displayExpr="name"
                                                valueExpr="id"
                                                disabled={true}
                                            >
                                            </SelectBox>

                                        </div>
                                    </div>
                                    <div className="row accordianLastRow">
                                        <div className="col-md-12">
                                            <SelectBox
                                                dataSource={dateSourceLocation}
                                                name="RLocation"
                                                value={formFields['RLocation']}
                                                onValueChanged={(e) => handleFieldChange('RLocation', e.value, e)}
                                                searchEnabled={true}
                                                stylingMode="outlined"
                                                labelMode="static"
                                                label={locationLabel}
                                                displayExpr="name"
                                                valueExpr="id"
                                                disabled={!isMoveOperation}
                                            >
                                            </SelectBox>
                                        </div>
                                    </div>
                                    {(!isMoveOperation &&
                                        formFields['selectedOperation'] !== operationAddInventory) && (
                                            <div className="row accordianLastRow">
                                                <div className="col-md-12">
                                                    <TextBox
                                                        value={formFields['ForSale']}
                                                        label="For Sale"
                                                        stylingMode="outlined"
                                                        labelMode="static"
                                                        readOnly={true}
                                                    />
                                                </div>
                                            </div>

                                        )}
                                    {(!isMoveOperation &&
                                        formFields['selectedOperation'] !== operationAddInventory) && (
                                            <div className="row accordianLastRow">
                                                <div className="col-md-12">
                                                    <TextBox
                                                        value={formFields['OutUnavailable']}
                                                        label="Growing"
                                                        stylingMode="outlined"
                                                        labelMode="static"
                                                        readOnly={true}
                                                    />
                                                </div>
                                            </div>

                                        )}
                                    <div className="row accordianLastRow">
                                        <div className="col-md-12">
                                            <NumberBox
                                                name="Quantity"
                                                value={formFields['Quantity']}
                                                onValueChanged={(e) => handleFieldChange('Quantity', e.value, e)}
                                                className="input-field"
                                                id="lukup-from"
                                                stylingMode='outlined'
                                                labelMode="static"
                                                label='Operation Quantity'
                                                min={0}
                                            />
                                        </div>
                                    </div>
                                    <div className="row accordianLastRow" visible={isMobileView}>
                                        <div className="col-md-12">
                                            <Button
                                                text="Save"
                                                useSubmitBehavior={true}
                                                type="default"
                                                className="accordianButton"
                                                visible={isMobileView}
                                                disabled={isFormSubmitted}
                                            />
                                            <Button className="accordianButton" onClick={handleReset} disabled={isFormSubmitted} visible={isMobileView} text={formatMessage('Reset')} />
                                            <Button onClick={Back} text="Back" icon="back" visible={isMobileView}>
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(InventoryOperation);